export default [
  {
    path: '/staticPages/userAgreementPage',
    name: 'userAgreementPage',
    component: () => import('@views/staticPages/userAgreement.vue'),
    meta: {
      title: '用户隐私协议'
    }
  },
  {
    path: '/staticPages/serviceAgreement',
    name: 'userAgreementPage',
    component: () => import('@views/staticPages/serviceAgreement.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/staticPages/aboutUs',
    name: 'aboutUs',
    component: () => import('@views/staticPages/aboutUs.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/staticPages/scoreRule',
    name: 'scoreRule',
    component: () => import('@views/staticPages/scoreRule.vue'),
    meta: {
      title: '积分规则'
    }
  },
  {
    path: '/staticPages/healthCommitment',
    name: 'healthCommitment',
    component: () => import('@views/staticPages/healthCommitment.vue'),
    meta: {
      title: '身体健康情况承诺书'
    }
  },
  {
    path: '/staticPages/InformationCommitment',
    name: 'InformationCommitment',
    component: () => import('@views/staticPages/InformationCommitment.vue'),
    meta: {
      title: '信息真实承诺函'
    }
  },
  {
    path: '/staticPages/invitationRule',
    name: 'invitationRule',
    component: () => import('@views/staticPages/invitationRule.vue'),
    meta: {
      title: '邀请好友规则'
    }
  },
  {
    path: '/staticPages/downLoad',
    name: 'downLoad',
    component: () => import('@views/staticPages/downLoad.vue'),
    meta: {
      title: '下载app中转页'
    }
  },
  {
    path: '/vivo/redirectUri',
    name: 'downLoad',
    component: () => import('@views/staticPages/demo.vue'),
    meta: {
      title: '下载app中转页'
    }
  },
  {
    path: '/staticPages/recharge',
    name: 'recharge',
    component: () => import('@views/staticPages/recharge.vue'),
    meta: {
      title: '充值协议'
    }
  },
  {
    path: '/staticPages/cashRule',
    name: 'recharge',
    component: () => import('@views/staticPages/cashRule.vue'),
    meta: {
      title: '充值协议'
    }
  }
]
